// import { useRef, useEffect } from 'react';
import { useEffect, useRef } from "react";
/**
 * MentionInput
 * - Highlights @handles
 * - Stores plain text
 * - Renders styled HTML
 */
export default function MentionTextArea({
  value,
  onChange,
  placeholder = 'Write a comment...',
  rows = 3,
  className = '',
}) {
  const ref = useRef(null);

  // Highlight @mentions
  const formatText = (text) => {
    if (!text) return '';
    return text
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(
        /(@[a-zA-Z0-9_]+)/g,
        `<span class="text-teal-400">$1</span>`
      )
      .replace(/\n/g, '<br/>');
  };

  // Keep DOM in sync with value
  useEffect(() => {
    if (!ref.current) return;

    const html = formatText(value);
    if (ref.current.innerHTML !== html) {
      ref.current.innerHTML = html;
    }
  }, [value]);

  // Handle input
  const handleInput = (e) => {
    const text = e.currentTarget.innerText;
    onChange(text);
  };

  return (
    <div className="relative">
      {/* Placeholder */}
      {!value && (
        <div className="pointer-events-none absolute top-4 left-4 text-slate-400">
          {placeholder}
        </div>
      )}

      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        className={`
          min-h-[${rows * 24}px]
          whitespace-pre-wrap
          break-words
          dark:bg-transparent
          dark:border
          dark:border-slate-700
          bg-slate-100
          dark:text-white
          text-black
          p-4
          rounded-xl
          outline-none
          ${className}
        `}
      />
    </div>
  );
}